import { useProjectId } from '@hooks/useProjectId'
import { Navigate } from 'react-router-dom'

export const CompleteSetup = () => {
	const { projectId } = useProjectId()

	return <Navigate to={`/${projectId}/setup`} replace />
}
